import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { Route,RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import Layout from './components/layout/Layout.jsx'
import Contact from './pages/contact/Contact.jsx'
import Home from './pages/home/Home.jsx'
import About from './pages/about/About.jsx'
import Offerings from './pages/offerings/Offerings.jsx'
import Careers from './pages/careers/Careers.jsx'
import CauseBranding from './pages/causeBranding/CauseBranding.jsx'
import TheImpactLeague from './pages/theImpactLeague/TheImpactLeague.jsx'
import MarketingBrands from './pages/marketingBrands/MarketingBrands.jsx'
import reportWebVitals from './reportWebVitals';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<Layout />}>
      <Route path='' element={<Home />} />
      <Route path='offerings' element={<Offerings />}/> 
      <Route path='about' element={<About />} />
      <Route path='careers' element={<Careers />} />
      <Route path='contact' element={<Contact />} />
      <Route path='theImpactLeague' element={<TheImpactLeague />} />
      <Route path='CauseBranding' element={<CauseBranding />} />
      <Route path='marketingBrands' element={<MarketingBrands />} /> 
    </Route>
  )
)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
